import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import HeroSection from "../components/HeroSection";
import InfoSection from "../components/InfoSection";
// import InfoCarouselSection from "../components/InfoCarouselSection";
import InfoSectionAlt from "../components/InfoSectionAlt";
import {
  homeObjOne,
  // homeObjTwo,
  homeObjThree,
} from "../components/InfoSection/Data";
import Services from "../components/Services";
import HostingService from "../components/HostingService";
import PurchaseHardware from "../components/PruchaseHardware";

function Home() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <HeroSection />
      <InfoSection {...homeObjOne} />
      <PurchaseHardware />
      {/* <InfoSection {...homeObjTwo} /> */}
      {/* <InfoCarouselSection {...homeObjTwo} /> */}
      <HostingService />
      <Services />
      <InfoSectionAlt {...homeObjThree} />

      <Footer />
    </>
  );
}

export default Home;
